import template from './category-detail-product-boxes-settings.html.twig';

const {Component} = Shopware;


Component.register('category-detail-product-boxes-settings', { // <-- same name like the directory to make it non-confusing
    template: template,

    inject: [
        'repositoryFactory',
        'TopdataPbCategoryExtensionApiService',
    ],

    data() {
        return {
            isLoading:                 false,
            isLoadingGroups:           false,
            availablePropertyGroups:   [], // <-- property groups that really occur in this category
            topdataPbCategoryExtension: null, // <-- this is the entity were the settings are stored, fetched from server
        };
    },

    metaInfo() {
        return {
            title: this.$tc('TopdataProductBoxesSW6.productBoxSettings.pageTitle')
        };
    },

    computed: {
        topdataPbCategoryExtensionRepository() {
            return this.repositoryFactory.create('topdata_pb_category_extension');
        },

        /**
         * Everything the user may pick: the property groups occurring in this category,
         * plus already selected groups that no longer occur (so they stay visible/deselectable).
         */
        propertyGroupChoices() {
            const selected = this.topdataPbCategoryExtension
                ? [
                    ...(this.topdataPbCategoryExtension.propertyGroups || []),
                    ...(this.topdataPbCategoryExtension.detailPropertyGroups || []),
                ]
                : [];

            const choices = this.availablePropertyGroups.map((group) => {
                return {
                    id:           group.id,
                    name:         group.name,
                    productCount: group.productCount,
                    isAvailable:  true,
                };
            });

            const availableIds = choices.map((choice) => choice.id);
            selected.forEach((entry) => {
                if (availableIds.includes(entry.id)) {
                    return;
                }

                choices.push({
                    id:           entry.id,
                    name:         entry.name || entry.id,
                    productCount: null,
                    isAvailable:  false,
                });
            });

            return choices;
        },

        /**
         * ids currently stored in the extension (the value of sw-multi-select)
         */
        selectedPropertyGroupIds() {
            if (!this.topdataPbCategoryExtension) {
                return [];
            }

            return (this.topdataPbCategoryExtension.propertyGroups || []).map((entry) => entry.id);
        },

        selectedDetailPropertyGroupIds() {
            if (!this.topdataPbCategoryExtension) {
                return [];
            }

            return (this.topdataPbCategoryExtension.detailPropertyGroups || []).map((entry) => entry.id);
        },

        /**
         * dropdown options: label = "Name (count)", absent selections are marked
         */
        propertyGroupSelectOptions() {
            const absentLabel = this.$tc('TopdataProductBoxesSW6.productBoxSettings.propertyGroupIds.absent');

            return this.propertyGroupChoices.map((choice) => {
                let label = choice.name;

                if (choice.productCount !== null) {
                    label += ` (${choice.productCount})`;
                }

                if (choice.isAvailable === false) {
                    label += ` – ${absentLabel}`;
                }

                return {
                    label: label,
                    value: choice.id,
                };
            });
        },
    },

    created() {
        // SW 6.7: swCategoryDetail is a Pinia store now (Shopware.State = legacy Vuex, module no longer exists)
        const store = Shopware.Store.get('swCategoryDetail');
        this.category = store ? store.category : null;
        if (!this.category) {
            return;
        }
        this.loadAvailablePropertyGroups();
        this.loadCategoryExtension();
    },

    methods: {
        loadAvailablePropertyGroups() {
            this.isLoadingGroups = true;

            return this.TopdataPbCategoryExtensionApiService.getPropertyGroupsOfCategory(this.category.id).then((groups) => {
                this.availablePropertyGroups = groups || [];
                this.isLoadingGroups = false;
            }).catch(() => {
                this.availablePropertyGroups = [];
                this.isLoadingGroups = false;
            });
        },

        onPropertyGroupChange(ids) {
            this._applySelection('propertyGroups', ids);
        },

        onDetailPropertyGroupChange(ids) {
            this._applySelection('detailPropertyGroups', ids);
        },

        _applySelection(key, ids) {
            if (!this.topdataPbCategoryExtension) {
                return;
            }

            const byId = {};
            this.propertyGroupChoices.forEach((choice) => {
                byId[choice.id] = choice;
            });

            this.topdataPbCategoryExtension[key] = (ids || []).map((id) => {
                return {
                    id:   id,
                    name: byId[id] ? byId[id].name : id,
                };
            });
        },

        loadCategoryExtension() {
            // TODO: this belongs in the TopdataPbCategoryExtensionApiService
            const criteria = new Shopware.Data.Criteria();
            criteria.addAssociation('propertyGroupXrefs');
            criteria.getAssociation('propertyGroupXrefs').addSorting(Shopware.Data.Criteria.sort('position', 'ASC'));
            criteria.addAssociation('propertyGroupXrefs.propertyGroup');
            criteria.addFilter(Shopware.Data.Criteria.equals('categoryId', this.category.id));
            this.topdataPbCategoryExtensionRepository.search(criteria, Shopware.Context.api).then((result) => {
                const model = result.first();
                if (model) {
                    // ---- existing category extension
                    this.topdataPbCategoryExtension = model;
                    this.topdataPbCategoryExtension.propertyGroups = (model.propertyGroupXrefs || [])
                        .filter((x) => x.slot === 'listing')
                        .map((x) => x.propertyGroup);
                    this.topdataPbCategoryExtension.detailPropertyGroups = (model.propertyGroupXrefs || [])
                        .filter((x) => x.slot === 'detail')
                        .map((x) => x.propertyGroup);
                } else {
                    // ---- new category extension
                    this.topdataPbCategoryExtension = {
                        id:                     Shopware.Utils.createId(),
                        categoryId:             this.category.id,
                        useParentCategory:      true,
                        isEnabled:              true,
                        propertyGroups:         [],
                        detailPropertyGroups:   [],
                    }
                }
            });
        },
        saveCategoryExtension() {
            this.isLoading = true;
            this.TopdataPbCategoryExtensionApiService.updateTopdataPbCategoryExtension(this.topdataPbCategoryExtension).then(() => {
                this.isLoading = false;
            })
        },
    },
    watch:   {
        topdataPbCategoryExtension: {
            handler(newValue, oldValue) {
                if (!oldValue) {
                    return;
                }
                this.saveCategoryExtension();
            },
            deep:      true,
            immediate: true,
        },
    }
});
